import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FixedPluginComponent } from './fixedplugin.component';

@NgModule({
	imports: [RouterModule, CommonModule],
	declarations: [FixedPluginComponent],
	exports: [FixedPluginComponent]
})
export class FixedPluginModule {}



// WEBPACK FOOTER //
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/app/shared/fixedplugin/fixedplugin.module.ts